// extracted by mini-css-extract-plugin
export default {"container":"TermsOfUse_container__-yzrH"};